import { render, staticRenderFns } from "./GameDownload.vue?vue&type=template&id=1286ee2c&scoped=true&"
import script from "./GameDownload.vue?vue&type=script&lang=js&"
export * from "./GameDownload.vue?vue&type=script&lang=js&"
import style0 from "./GameDownload.vue?vue&type=style&index=0&id=1286ee2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286ee2c",
  null
  
)

export default component.exports